module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"soldAndShippedBy":"Vendu et expédié par :"},"en":{"soldAndShippedBy":"sold and shipped by :"},"es":{"soldAndShippedBy":"Vendido y enviado por :"},"de":{"soldAndShippedBy":"Verkauft und versandt von :"},"it":{"soldAndShippedBy":"Venduto e spedito da :"},"nl":{"soldAndShippedBy":"Verkocht en verzonden door :"},"pt":{"soldAndShippedBy":"Vendido e enviado por :"}}')
  delete Component.options._Ctor
}
